<template>
  <vg-card>
    <vg-view-field-list class="no-hr">
      <dp-application-view-field
          v-for="(field, index) in sortedFields"
          :key="field.applicationAttributeFieldId"
          :value="field"
          label-width="120px"
          :bold-value="index < 2"
          label-suffix="："
      />
      <dp-application-view-field
          v-if="this.passCardType === 'TENANT_EMPLOYEE'"
          :value="{attributeName: '有效期至', value: expireTimeFilter(expireTime)}"
          label-width="120px"
          label-suffix="："
      />
    </vg-view-field-list>
  </vg-card>
</template>
<script>

import samplePhotos from "@/assets/myElectronicPass/samplePhotos.png";
import {client} from "@/libraries/http";
import VgCard from "@/components/Commons/VgCard.vue";
import VgViewFieldList from "@/components/Commons/VgViewFieldList.vue";
import DpApplicationViewField
  from "@/views/DigitalPassApplications/DigitalPassApplication/DpApplicationViewField/index.vue";
import expireTime from "@/filters/expireTime";

export default {
  name: "decorationPersonnelInformation",
  components: {
    DpApplicationViewField,
    VgViewFieldList,
    VgCard,
  },
  props: {},
  data() {
    return {
      imgSrc: samplePhotos,
      passCardApplicationResourceFieldList: undefined,
      expireTime,
    };
  },
  created() {
    this.getDetail();
  },
  computed: {
    sortedFields() {
      const fields = this.passCardApplicationResourceFieldList || [];
      const orderMap = {
        'PERSONAL_NAME': 1,
        'CONSTRUCTION_LOCATION': 2,
        'TENANT_COMPANY': 3,
        'PHONE_NUMBER': 4,
        'PERSONAL_PHOTO': 5,
        'PROJECT_ID': 6,
        'BRAND': 7,
        'CONSTRUCTION_TYPE': 8,
        'CONSTRUCTOR': 9,
        'CONSTRUCTION_CONTENT': 10,
        'CONSTRUCTION_START_TIME': 11,
        'CONSTRUCTION_END_TIME': 12,
        // 'ID_CARD_PHOTO_FRONT': 12,
        // 'ID_CARD_PHOTO_BACK': 13,
        // 'TP_OVERTIME_APPROVAL_PHOTO': 14,
      }

      return fields.filter(field => orderMap[field.attributeType])
          .sort((l, r) => {
            return orderMap[l.attributeType] - orderMap[r.attributeType]
          })
    }
  },
  methods: {
    expireTimeFilter(value) {
      return expireTime(value)
    },
    getDetail() {
      console.log(this.$route.query.passCardApplicationInfoId, "1132465")
      client.get("/api/h5/passcard/profile-details", {
        params: {
          passCardApplicationInfoId: this.$route.query.passCardApplicationInfoId,
        }
      }).then(res => {
        console.log(res, "个人资料详情");
        this.passCardApplicationResourceFieldList = res.data.passCardApplicationResourceFieldList;
        this.expireTime = res.data.expireTime;
        this.passCardType = res.data.passCardType;
      });
    },
  },
};
</script>
<style scoped>
.app >>> .van-cell__value {
  text-align: left;
}

.app {
  border: 1px solid #E7E5E7;
  border-radius: 10px;
  margin: 15px;
}

.app >>> .van-cell::after {
  border-bottom: 0px;
}

</style>
